import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { FontAccessibilityProvider } from './context/FontAccessibilityContext';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import SocialMediaBar from './Components/SocialmediaBar';
import HomePage from './Pages/HomePage';
import About from './Pages/About';
import IntroductionPage from './Pages/Introduction';
import Repositories from './Pages/Repositories';
import Aram from './Pages/Aram';
import Porul from './Pages/Porul';
import Inbam from './Pages/Inbam';
import Features from './Pages/Features';
import FindBranches from './Pages/FindBranches';
import AboutUs from './Pages/AboutUs';
import Pds from './Pages/Pds';
import Dccws from './Pages/Dccws';
import Mudhalvar from './Pages/Mudhalvar';
import QuickCommerce from './Pages/QuickCommerce';
import Thayumanavar from './Pages/Thayumanavar';
import Kcc from './Pages/Kcc';
import CropLoanWaiver from './Pages/CropLoanWaiver';
import Tnsc from './Pages/Tnsc';
import Dccb from './Pages/Dccb';
import Kooturavu from './Pages/Kooturavu';
import Amma from './Pages/Amma';
import Ucb from './Pages/Ucb';
import Agri from './Pages/Agri';
import Paccs from './Pages/Paccs';
import Agrimarketing from './Pages/Agrimarketing';
import Society from './Pages/Society';
import Loan from './Pages/Loan';
import Auto from './Pages/Auto';
import Dccwss from './Pages/Dccwss';
import EVadagai from './Pages/EVadagai';
import Uccs from './Pages/Uccs';
import Ecs from './Pages/Ecs';
import Pcardb from './Pages/PCARDB';
import LoginPortal from './Pages/LoginPortal';
import Marunthagam from './Pages/Marunthagam';
import DmsDashboard from './Pages/dms';
import PolicyActsPublic from './Pages/PolicyActsPublic';
import OurProducts from './Pages/OurProducts';
import Lamps from './Pages/Lamps';
import ContactUs from './Pages/ContactUs';
import ChatBox from './Components/ChatBox';
// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRoutes = () => {
  const location = useLocation();

  return (
    <div className="App flex flex-col min-h-screen">
      <ScrollToTop />
      <Navbar />
      
      {/* Show SocialMediaBar on all pages except homepage */}
      {location.pathname !== '/' && <SocialMediaBar />}

      {/* IMPORTANT: Added id="main-content" here for font accessibility */}
      <main id="main-content" className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/dccws" element={<Dccws />} />
          <Route path="/services/pds" element={<Pds />} />
          <Route path="/quick-commerce" element={<QuickCommerce />} />
          <Route path="/mudhalvar" element={<Mudhalvar />} />
          <Route path="/thayumanavar" element={<Thayumanavar />} />
          <Route path="/kcc" element={<Kcc />} />
          <Route path="/crop-loan-waiver-2026" element={<CropLoanWaiver />} />
          <Route path="/tnsc" element={<Tnsc />} />
          <Route path="/dccb" element={<Dccb />} />
          <Route path="/Paccs" element={<Paccs />} />
          <Route path="/agri-marketing" element={<Agrimarketing />} />
          <Route path="/Dccwss" element={<Dccwss />} />
          <Route path="/society-registration" element={<Society />} />
          <Route path="/loan" element={<Loan/>} />
          <Route path="/auto" element={<Auto />} />
          <Route path="/kooturavu-marundhagam" element={<Kooturavu />} />
          <Route path="/amma-marundhagam" element={<Amma />} />
          <Route path="/services/evadagai" element={<EVadagai />} />
          <Route path="/ucb" element={<Ucb />} />
          <Route path="/uccs" element={<Uccs/>} />
          <Route path="/agri-mechanism" element={<Agri />} />
          <Route path="/repositories" element={<Repositories />} />
          <Route path="/section1" element={<Aram />} />
          <Route path="/section2" element={<Porul />} />
          <Route path="/section3" element={<Inbam />} />
          <Route path="/aram" element={<Aram />} />
          <Route path="/porul" element={<Porul />} />
           <Route path="/lamps" element={<Lamps />} />
          <Route path="/inbam" element={<Inbam />} />
          <Route path="/login-portal" element={<LoginPortal/>} />
          <Route path="/sections" element={<IntroductionPage />} />
          <Route path="/findourbranches" element={<FindBranches />} />
          <Route path="/features" element={<Features />} />
          <Route path="/ecs" element={<Ecs />} />
          <Route path="/pcardb" element={<Pcardb/>} />
          <Route path="/services/marunthagam" element={<Marunthagam />} />
           <Route path="/policy/acts-and-rules" element={<PolicyActsPublic/>} />
           <Route path="/dms" element={<DmsDashboard/>} />
             <Route path="/our-products" element={<OurProducts/>} />
           <Route path="/contact-us" element={<ContactUs/>} />
          {/* Add screen reader route when ready */}
          {/* <Route path="/screen-reader" element={<ScreenReaderAccess />} /> */}
        </Routes>

        {location.pathname === '/' && <IntroductionPage />}
      </main>

      <Footer />
      <ChatBox />
    </div>
  );
};

function App() {
  return (
    <Router>
      <LanguageProvider>
        <FontAccessibilityProvider>
          <AppRoutes />
        </FontAccessibilityProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;